import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/655371c3-d068-4a01-88b7-a661716cb60c";
export const REGISTER_URL = "https://a.ntrk2.com/ce619a0d-d58d-4177-a2ea-1d940754e3ff";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "https://mainwow.live/chat";

export * from "./codes";
export * from "./context";
